import { Component } from '@angular/core';
import { ButtonComponent } from './button.component';

@Component({
    selector: 'app-back-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class BackButtonComponent extends ButtonComponent {
    constructor() {
        super();

        this.hostClass += ' mb-3';
        this.icon = 'chevron_left';
        this.type = 'link';
    }
}
